import { render, staticRenderFns } from "./FailedJobs.vue?vue&type=template&id=b0fdf42a&"
import script from "./FailedJobs.vue?vue&type=script&lang=js&"
export * from "./FailedJobs.vue?vue&type=script&lang=js&"
import style0 from "./FailedJobs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports